import { Icon } from '@chakra-ui/react';

export default function SFMinusCircleFillIcon(props) {
  return (
    <Icon
      width={14}
      height={14}
      viewBox='0 0 14 14'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7 14C6.04379 14 5.14248 13.817 4.29608 13.451C3.45425 13.085 2.71078 12.5794 2.06569 11.9343C1.42059 11.2892 0.915033 10.5458 0.54902 9.70392C0.183007 8.85752 0 7.95621 0 7C0 6.04379 0.183007 5.14477 0.54902 4.30294C0.915033 3.45654 1.4183 2.71078 2.05882 2.06569C2.70392 1.42059 3.44739 0.915033 4.28922 0.54902C5.13562 0.183007 6.03693 0 6.99314 0C7.94935 0 8.85065 0.183007 9.69706 0.54902C10.5435 0.915033 11.2892 1.42059 11.9343 2.06569C12.5794 2.71078 13.085 3.45654 13.451 4.30294C13.817 5.14477 14 6.04379 14 7C14 7.95621 13.817 8.85752 13.451 9.70392C13.085 10.5458 12.5794 11.2892 11.9343 11.9343C11.2892 12.5794 10.5435 13.085 9.69706 13.451C8.85523 13.817 7.95621 14 7 14ZM4.23431 7.60392H9.77941C9.97614 7.60392 10.1363 7.5536 10.2598 7.45294C10.3879 7.34771 10.452 7.20131 10.452 7.01373C10.452 6.82157 10.3902 6.67288 10.2667 6.56765C10.1477 6.46242 9.98529 6.4098 9.77941 6.4098H4.23431C4.02843 6.4098 3.86373 6.46242 3.7402 6.56765C3.61667 6.67288 3.5549 6.82157 3.5549 7.01373C3.5549 7.20131 3.61667 7.34771 3.7402 7.45294C3.8683 7.5536 4.03301 7.60392 4.23431 7.60392Z'
        fill='#485D7D'
      />
    </Icon>
  );
}
